export const locale = {
    lang: 'en',
    data: {
        MOVE_CARDS: 'Move cards',
        SELECTION: 'Selection',
        ACTIVITY: 'Activity',
    }
};
